import { ReactComponent as ChevronDown } from '@public/icons/chevron-down.svg';
import Icon from '../atoms/Icon';

const IconChevronDown = (props) => <Icon as={ChevronDown} {...props} />;

IconChevronDown.propTypes = Icon.propTypes;

export default IconChevronDown;
